/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-30 17:04:13
 * @Description: 
 */
/**
  * 产品池 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const mangheorder = {
    // 商品订单列表
    goodsOrderList (params) {
        return axios.get(api + 'manghegoodorder/list', { params: params })
    },
    // 商品订单详情
    goodsOrderDetail (params) {
        return axios.get(api + 'manghegoodorder/detail', { params: params })
    },
    // 订单快照
    photo (params) {
        return axios.get(api + 'manghegoodorder/photo', { params: params })
    },
    // 商品订单发货
    goodsOrderShip (params) {
        return axios.post(api + 'manghegoodorder/ship', qs.stringify(params))
    },
    // 商品订单批量发货
    allShip (params) {
        return axios.post(api + 'manghegoodorder/allship', qs.stringify(params))
    },
    //导出商品订单
    exportgoodorder (params) {
        return axios.post(api + 'manghegoodorder/export', qs.stringify(params))
    },
    // 购买材料订单
    dataOrderList (params) {
        return axios.get(api + 'manghedataorder/list', { params: params })
    },
    //导出材料订单
    exportdataorder (params) {
        return axios.get(api + 'manghedataorder/export', { params: params })
    },
    // 回收订单
    recoveryOrderList (params) {
        return axios.get(api + 'mangherecoveryorder/list', { params: params })
    },
    //导出回收订单
    exportrecoveryorder (params) {
        return axios.get(api + 'mangherecoveryorder/export', { params: params })
    },
    // 盲盒订单
    boxOrderList (params) {
        return axios.get(api + 'boxorder/list', { params: params })
    },
    //导出盲盒订单
    exportboxorder (params) {
        return axios.get(api + 'boxorder/export', { params: params })
    },
    // 盲盒订单详情
    boxOrderDetail (params) {
        return axios.get(api + 'boxorder/detail', { params: params })
    },
    //盲盒退款
    manghereturn (params) {
        return axios.post(api + 'boxorder/recovery', qs.stringify(params))
    },
    // 邮费订单
    fareOrderList (params) {
        return axios.get(api + 'manghefareorder/list', { params: params })
    },
    // 邮费订单详情
    fareOrderDetail (params) {
        return axios.get(api + 'manghefareorder/detail', { params: params })
    },
    //导出运费订单
    exportfareorder (params) {
        return axios.get(api + 'manghefareorder/export', { params: params })
    },
}


// 导出接口
export default mangheorder